module.exports = __webpack_public_path__ + "1d705462d43348c211c8d3ac2654b4a2.jpg";